import { createLocalVue, shallowMount } from "@vue/test-utils";
import Vuex from "vuex";
import NotificationToast from "@/components/core/NotificationToast.vue";

const localVue = createLocalVue();
localVue.use(Vuex);

describe("NotificationToast Component mount", () => {
  let store;
  let wrapper;

  beforeEach(() => {
    store = new Vuex.Store({
      state: {
        notificationToast: {
          type: "",
          message: ""
        }
      }
    });

    wrapper = shallowMount(NotificationToast, {
      store,
      localVue
    });
  });

  it("Renders del component NotificationToast", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
